module.exports = __webpack_public_path__ + "static/coworking-8f148ccf0645a122863deb9de8a0f07e.jpg";